var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 6.24219C5.1875 5.6597 5.6597 5.1875 6.24219 5.1875H9.75781C10.3403 5.1875 10.8125 5.6597 10.8125 6.24219V9.75781C10.8125 10.3403 10.3403 10.8125 9.75781 10.8125H6.24219C5.6597 10.8125 5.1875 10.3403 5.1875 9.75781V6.24219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 6.24219C5.1875 5.6597 5.6597 5.1875 6.24219 5.1875H9.75781C10.3403 5.1875 10.8125 5.6597 10.8125 6.24219V9.75781C10.8125 10.3403 10.3403 10.8125 9.75781 10.8125H6.24219C5.6597 10.8125 5.1875 10.3403 5.1875 9.75781V6.24219Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/paused-icon.802bf6a1475e08563550abdbc3d6a4c4.svg";
export { ForwardRef as ReactComponent };